import { render } from "./ResourceCentreDetailView.vue?vue&type=template&id=3e1901e9&scoped=true"
import script from "./ResourceCentreDetailView.vue?vue&type=script&lang=js"
export * from "./ResourceCentreDetailView.vue?vue&type=script&lang=js"

import "./ResourceCentreDetailView.vue?vue&type=style&index=0&id=3e1901e9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1901e9"]])

export default __exports__